export const isFunc = (value: any): boolean => typeof value === 'function';
